import { getOr, every, flow, get, negate, isEqual, identity } from 'lodash/fp';
import isCustomerViewingCustomProduct from '../../../../../../../../helpers/isCustomerViewingCustomProduct';

export default item => every(
  identity,
  [
    getOr(false, 'itemProduct.isValid')(item),
    !getOr(false, 'itemProduct.isStockProduct')(item),
    !isCustomerViewingCustomProduct(item),
    flow(
      get('itemProduct.productStatus'),
      negate(isEqual('Discontinued')),
    ),
  ],
);
